import type { FC } from 'react'
import Responses from '../responses.js'
import type { PollViewProps } from './types.js'

const ResponsesView: FC<PollViewProps> = ({ entity: poll }) => <Responses poll={poll} />

export default ResponsesView
